// @flow
import { toast } from '../store/StoreUtil';
import t from '../i18n/I18n';
import { RepoItem } from '../autogenerated/ZoomBridge';

export class ClipBoardUtil {
  static copyToClipBoard(text: string) {
    let textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    toast(t('COPY_TO_CLIPBOARD'));
  }

  static extractAssetIDs(assets: Array<RepoItem>) {
    const items = [];
    assets.forEach((repo) => {
      items.push(repo.getFuid());
    });
    const text = items.join(', ');
    return text;
  }

  static extractAssetPaths = (assets: Array<RepoItem>): void => {
    const items = [];
    assets.forEach((repo) => {
      items.push(repo.getRemotePath());
    });
    const text = items.join(', ');
    return text;
  };
}
